import { AdminTemplate, MerchantAccount } from "../../components"

export const MerchantAccountComponent = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'Cari',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <MerchantAccount />
    </AdminTemplate>
  )
}
